module.exports = __webpack_public_path__ + "img/1525917614.3123ed74.jpg";